<template>
  <section class="dashboard">
    <div class="row">
      <div class="col_12">
        <img
          src="@/assets/img/preloader_icon.svg"
          alt=""
          class="preloader"
          v-if="preloader"
        />

        <img
          src="@/assets/img/meeting_ended_icon.svg"
          alt=""
          class="smile"
          v-if="smile"
        />

        <p class="tac terms_title">
          <slot></slot>
        </p>

        <router-link
          to="/user_rooms"
          class="color_btn hover_op"
          v-if="authenticated === true && home_button == true"
          >Return home</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "roomInfoScreen",

  props: {
    preloader: {
      type: Boolean,
      default: false,
    },

    smile: {
      type: Boolean,
      default: false,
    },

    home_button: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    authenticated() {
      return this.$store.state.userAuthenticated;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  display: flex;
  align-items: center;
}

.row {
  width: 100%;
  margin-left: 0;
}

.terms_title {
  margin-top: 0;
}

.color_btn {
  width: 152px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 72px;

  @media all and (max-width: 767px) {
    margin-top: 34px;
  }
}
</style>